import type { ParsedUrlQuery } from 'querystring';
import { isWwsWeddingWebsiteV2, type WeddingWebsiteQuery } from '../types/graphql';

// Sites rendered as a single continuous-scroll page show every section on
// one URL by design, so there is no "other route" to scope data to. Shared
// by SSR (getServerSideProps) and the client (WWSQueryContext) so both sides
// agree on whether route-scoping applies.
export function isSinglePageLayoutFromQuery(
  data: WeddingWebsiteQuery,
  query: ParsedUrlQuery
): boolean {
  return (
    query['viewSinglePage'] === 'true' ||
    query['preview'] === 'true' ||
    (isWwsWeddingWebsiteV2(data.weddingWebsiteResult) &&
      data.weddingWebsiteResult.layout === 'single-page')
  );
}
